import React from 'react';
import { ReactMic } from '@cleandersonlobo/react-mic';
import axios from "axios";
import { config } from "../../../app/config";
import TranslationService from "../../../app/services/TranslationService";
import {Button} from "../../icymat-design/Button";


export class ListenButton extends React.Component {
    constructor(props) {
        super(props);

        this.onStop = this.onStop.bind(this);
    };

    onData = (recordedBlob) => {}

    onStop(recordedBlob) {
        this.props.startCatchTextFromMic();

        let reader = new FileReader();
        let that = this;

        reader.onload = function() {
            let dataUrl = reader.result;
            let base64 = dataUrl.split(',')[1];

            axios.post(config.apiAddress + '/speech/recognition', {base64: base64})
                .then(function (response) {
                    that.props.catchTextFromMic(response.data.message);
                }).catch(function(error) {
                    that.props.error(TranslationService.trans(that.props.lang, 'main.recording_error'));
                });
        };
        reader.readAsDataURL(recordedBlob.blob);
    }

    render() {
        return (
            <div id={"listening"}>
                <ReactMic
                    width={0}
                    height={0}
                    record={this.props.listening}
                    className="sound-wave"
                    onStop={this.onStop}
                    onData={this.onData}
                    strokeColor="#000000"
                    backgroundColor="#ff0000" />
                <Button
                    color={'main'}
                    secondary={true}
                    icon={'imd-icon imd-icon-microphone-solid'}
                    onClick={() => this.props.startInteraction()}
                />
            </div>
        );
    }
}
